import { jsx as a } from "react/jsx-runtime";
import { SvgIcon as o } from "../SvgIcon.js";
const p = (l) => /* @__PURE__ */ a(o, { ...l, children: /* @__PURE__ */ a("path", { d: "M4.783 1.25a.625.625 0 0 0-.433.183l-2.5 2.5a.625.625 0 1 0 .884.884l1.433-1.433v5.158a3.134 3.134 0 0 0 3.125 3.125h2.083v6.458a.625.625 0 1 0 1.25 0v-6.458h2.083a3.134 3.134 0 0 0 3.125-3.125V3.384l1.434 1.433a.625.625 0 1 0 .883-.884l-2.5-2.5a.625.625 0 0 0-.883 0l-2.5 2.5a.626.626 0 1 0 .883.884l1.433-1.433v5.158a1.865 1.865 0 0 1-1.875 1.875H7.292a1.865 1.865 0 0 1-1.875-1.875V3.384L6.85 4.817a.625.625 0 1 0 .884-.884l-2.5-2.5a.625.625 0 0 0-.451-.183Z" }) });
export {
  p as Split
};
//# sourceMappingURL=Split.js.map
